ready().then(function() {
    let headerAnchors = $('header .nav-anchors-container');
    let hash = window.location.hash.replace('#', '');

    if (! hash) {
        return;
    }

    // Wait until everything is ready, so correct position can be determined (see VER-3024)
    Promise.all([StateManager.resourcesLoaded, StateManager.stylesheetsLoaded, StateManager.criticalCssRemoved, StateManager.cookieDialogReady]).then(function() {
        scrollToTarget('#nav-' + hash);
    });

    //Smooth scroll to component
    function scrollToTarget(target)
    {
        let header = $('header.header'),
            mainNav = $('header .nav-container'),
            headerAnchorsOutsideHeader = header.height() >= headerAnchors.offset().top - header.offset().top, // Because styling approach can differentiate per site
            offset = 0,
            headerHeight = header.height() || 0,
            headerAnchorsHeight = 0,
            mainNavHeight = 0,
            adminbarHeight = 0;

        if ($(target).length === 0) {
            console.warn('ScrollTo anchor element not found:' + target);
            return;
        }

        // Support for floating in-page navigation
        if (headerAnchors.hasClass('is-visible')) {
            headerAnchorsHeight = headerAnchors.height();
        } else {
            headerAnchors.addClass('notransition is-visible');
            headerAnchorsHeight = headerAnchors.height(); // Get height for when it isn't floating yet
            headerAnchors.removeClass('notransition is-visible');
        }

        // Support for conditionally hidden main nav (dbb + cargo)
        if (headerAnchorsOutsideHeader === false && mainNav.attr('data-navbar-state') === 'navbar-scroll') {
            mainNav.addClass('notransition').attr('data-navbar-state', 'navbar-default');
            mainNavHeight = -mainNav.height(); // Subtract height for when it isn't showing yet
            mainNav.attr('data-navbar-state', 'navbar-scroll');
            setTimeout(function () {
                mainNav.removeClass('notransition'); // setTimout prevents flickering
            }, 1);
        }

        // Support for wpadminbar
        if ($('body').hasClass('admin-bar')) {
            adminbarHeight = parseInt($('html').css('marginTop'));
        }

        // Calculate dynamic offset
        offset = headerHeight + headerAnchorsHeight + mainNavHeight + adminbarHeight;

        $('html, body').scrollTop($(target).offset().top - offset);
    }
});
